import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../Auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  
  constructor(
    public authService: AuthService,
    public router: Router
  ){ }

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
      console.log("canActivate");
    if (this.authService.user.value == null) {
      console.log("canActivate => auth User");
      let currentUser = await this.authService.getUser();
      if (!currentUser) {
        alert("User is not signed in");
        this.router.navigate(['session/signin'])
      }
    }
    return true;
  }

}